import { render, staticRenderFns } from "./caixaIndicador.vue?vue&type=template&id=055a54e6&scoped=true&"
import script from "./caixaIndicador.vue?vue&type=script&lang=js&"
export * from "./caixaIndicador.vue?vue&type=script&lang=js&"
import style0 from "./caixaIndicador.vue?vue&type=style&index=0&id=055a54e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055a54e6",
  null
  
)

export default component.exports